import { render, staticRenderFns } from "./AppBenifits.vue?vue&type=template&id=5a150e33&scoped=true&"
import script from "./AppBenifits.vue?vue&type=script&lang=js&"
export * from "./AppBenifits.vue?vue&type=script&lang=js&"
import style0 from "./AppBenifits.vue?vue&type=style&index=0&id=5a150e33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a150e33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a150e33')) {
      api.createRecord('5a150e33', component.options)
    } else {
      api.reload('5a150e33', component.options)
    }
    module.hot.accept("./AppBenifits.vue?vue&type=template&id=5a150e33&scoped=true&", function () {
      api.rerender('5a150e33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AppBenifits.vue"
export default component.exports